import { ApplicationType } from "../../../core/constants/application-type.enum";
import { CompanyType } from "../../../core/constants/company-type.enum";

export interface ConversationResponse {
  content: Conversation[];
  totalPages: number;
  totalElements: number;
  size: number;
  numberOfElements: number;
}

export interface Conversation {
  id: number;
  category: string;
  subCategory: string;
  frontOfficeApplicationId: string;
  isActive: boolean;
  unreadMessagesCount: number;
}

export interface MessagesResponse {
  id: number;
  category: string;
  subCategory: string;
  frontOfficeApplicationId: string;
  isActive: boolean;
  unreadMessagesCount: number;
  disableReason: string;
  updatedAt: Date;
  messages: Message[];
  backOfficeApplicationId: number;
}

export interface Message {
  id: number;
  conversationId: number;
  content: string;
  senderId: number;
  isRead: boolean;
  createdAt: Date;
  documents: MessageDocument[];
  isExternalMessage: boolean;
  senderFirstName: string;
  senderLastName: string;
}

export interface MessageDocument {
  code: string;
  fileName: string;
  contentType: string;
  id: number;
}

export interface MessageGroup {
  date: Date;
  messages: Message[];
}

export class NewMessage {
  //@ts-ignore
  content: string | null;
  //@ts-ignore
  documentIds: number[];
  //@ts-ignore
  applicationId: string;
}

export class ConversationRequest {
  pageNumber: number | null = 0;
  pageSize: number | null = 10;
  searchText: string | null = null;

  public getParams(): string {
    const params = new URLSearchParams();

    if (this.pageNumber !== null) {
      params.append('pageNumber', this.pageNumber.toString());
    }

    if (this.pageSize !== null) {
      params.append('pageSize', this.pageSize.toString());
    }

    const q = (this.searchText ?? '').trim();
    if (q) {
      params.append(`searchText`, encodeURIComponent(q));
    }

    const query = params.toString();
    return query ? `?${query}` : '';
  }
}

export interface ConversationApplicationsResponse {
  content: ConversationApplication[];
  totalPages: number;
  totalElements: number;
  size: number;
  numberOfElements: number;
  number: number;
}

export interface ConversationApplication {
  conversationId: number;
  applicationId: number;
  opfCode: CompanyType;
  nameOfCompany: string;
  applicationTypeId: number;
}

export class ConversationApplicationRequest {
  pageNumber: number | null = 0;
  pageSize: number | null = 10;
  searchText: string | null = null;
  applicationType!: string;

  public getParams(): string {
    const params = new URLSearchParams();
    params.append('applicationType', this.applicationType.toString());

    if (this.pageNumber !== null) {
      params.append('pageNumber', this.pageNumber.toString());
    }

    if (this.pageSize !== null) {
      params.append('pageSize', this.pageSize.toString());
    }

    const q = (this.searchText ?? '').trim();
    if (q) {
      params.append(`searchText`, encodeURIComponent(q));
    }

    const query = params.toString();
    return query ? `?${query}` : '';
  }
}

export enum CommunicationContent {
  MAIN_REQUESTS = 'MAIN_REQUESTS',
  SUBMIT_REQUESTS = 'SUBMIT_REQUESTS',
  REQUEST_CHAT = 'REQUEST_CHAT'
}

export const inquiryTopics = [
  {
    id: 1,
    name: 'Questions about the application'
  }
]

export const applicationTypes = [
  {
    id: ApplicationType.REGISTRATION,
    name: 'Registration'
  },
  {
    id: ApplicationType.POST_REGISTRATION,
    name: 'Post - registration'
  }
]